"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOTE_AUTHENTICATOR_TYPE = void 0;
const REMOTE_AUTHENTICATOR_TYPE = exports.REMOTE_AUTHENTICATOR_TYPE = {
  REMOTE_SERVER_AUTH: 1,
  LOCAL_AUTH: 2,
  LDAP_AUTH: 3,
  GENERIC_AUTH: 4
};